/**
 * A place for common tasking things
 */
namespace appn.tasks {

    export function init(firstToClaimGuid: string, allToCompleteGuid: string, setUsersList: boolean) {
        // Handle Is All Day toggling
        $('.task-isAllDay').change(function() {
            if ((this as HTMLInputElement).checked) {
                $('.task-startByCompleteBy-group').hide();
                $('.task-allDayDate-group').show();
                return;
            }

            $('.task-startByCompleteBy-group').show();
            $('.task-allDayDate-group').hide();
        });

        // Hide Reassign if it all to complete
        disableReassign($('.task-appUserId'), allToCompleteGuid);
        $('.task-appUserId').on('change', function(e: Event) {
            disableReassign($(this), allToCompleteGuid);
        });

        // Handle CanReassign toggling
        $('.task-canReassign').change(function(e) {
            if ($(this).prop('checked'))
                $('.task-reassignType').show();
            else
                $('.task-reassignType').hide();
        });
        $('.task-canReassign').trigger('change');

        const $selectedTargetUsersOption = $('#Task_TargetUserType,#Template_Task_TargetUserType');
        const $formGroupTargetGroup = $('.form-control-AssignToGroup');
        const $formGroupTargetUsers = $('.form-control-AssignToUsers');
        const $assignToUserControlsCol = $('.assignToUserControlsCol');
        const $assignToUser = $('.task-appUserId');

        const hideFirstToClaimUi = function() {
            $assignToUserControlsCol.removeClass('col-md-8').addClass('col-md-4');
            $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').hide();
            $assignToUserControlsCol.find('.input-group-hook').removeClass('input-group');
            $formGroupTargetUsers.hide();
            $formGroupTargetGroup.hide();
            $('.targetedUserCountMessage').hide();
        };

        const showFirstToClaimUi = function() {
            $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
            $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
            $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
            toggleTargetGroup();
            toggleTargetUsers();
            $('.targetedUserCountMessage').show();
        };

        // Fires when a user is selected/changed
        $assignToUser.on('change', function(e) {

            // Auto set the timezone field to match users TZ when a user is selected
            const selectedTz = $(this).find(':selected').data('appn-tz');
            if (selectedTz)
                $('.task-timezone').val(selectedTz);

            // Handle First User to Claim
            if ($(this).val() === firstToClaimGuid || $(this).val() === allToCompleteGuid)
                showFirstToClaimUi();
            else
                hideFirstToClaimUi();
        });

        const toggleTargetGroup: Function = function() {
            if (($assignToUser.val() === firstToClaimGuid || $assignToUser.val() === allToCompleteGuid) &&
                $selectedTargetUsersOption.val() === 'Group') {

                $formGroupTargetUsers.hide();
                $formGroupTargetGroup.show();

                $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
                $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
                $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
            }
        };

        const toggleTargetUsers: Function = function() {
            if (($assignToUser.val() === firstToClaimGuid || $assignToUser.val() === allToCompleteGuid) &&
                $selectedTargetUsersOption.val() === 'Users') {

                $formGroupTargetGroup.hide();
                $formGroupTargetUsers.show();

                $assignToUserControlsCol.removeClass('col-md-4').addClass('col-md-8');
                $assignToUserControlsCol.find('.input-group-prepend,.input-group-append-select').show();
                $assignToUserControlsCol.find('.input-group-hook').addClass('input-group');
            }
        };

        $selectedTargetUsersOption.change(function(e) {
            toggleTargetGroup();
            toggleTargetUsers();
        });

        toggleTargetGroup();
        toggleTargetUsers();

        // Filter User list when restrict to group is changed
        if (setUsersList) {
            const $restrictToGroup = $('#Task_RestrictToGroup,#Template_Task_RestrictToGroup');

            $restrictToGroup.change(function() {
                tasks.filterAssignedToUsersList($(this));
                tasks.filterTargetGroupList($(this));
                tasks.filterTargetUsersList($(this));
                select.init();
            });

            tasks.filterAssignedToUsersList($restrictToGroup);
            tasks.filterTargetGroupList($restrictToGroup);
            tasks.filterTargetUsersList($restrictToGroup);
            select.init();
        }

        appn.dialog.showBillUpgradeOnClick(function() {
            // Reset the selected value to none if the dialog was shown
            $('.task-appUserId').val(appn.emptyString).change();
        });
    }

    function disableReassign(element: JQuery<HTMLElement>, allToCompleteGuid: string) {
        if ($(element).val() === allToCompleteGuid) {
            $('.canReassign').hide();
            ui.disableElement($('.task-canReassign'));
            $('.task-canReassign').prop('checked', false);
            return;
        }

        $('.canReassign').show();
        ui.enableElement($('.task-canReassign'));
    }

    export function initRecurring() {
        $('.taskRecurring-isRecurringTask').change(function() {
            if ((this as HTMLInputElement).checked) {
                $('.startby-form-group').hide();
                $('.completeby-form-group').hide();
                $('#editRecurringConfigBtn').show();
                $('#recurringTaskDialog').modal('show');
                return;
            }

            $('.startby-form-group').show();
            $('.completeby-form-group').show();
            $('#editRecurringConfigBtn').hide();
        });

        $('#editRecurringConfigBtn').off().on('click', function(e) {
            e.preventDefault();
            $('#recurringTaskDialog').modal('show');
        });

        // DAILY,WEEKLY,MONTHLY,YEARLY taskRecurringType
        const toggleTaskRecurringType = function(taskRecurringType: any) {

            switch (taskRecurringType) {
                case 'Daily': {
                    $('.repeat-every').text('days');
                    $('.recurring-weekly-group').hide();
                    break;
                }
                case 'Weekly': {
                    $('.repeat-every').text('weeks');
                    $('.recurring-weekly-group').show();
                    break;
                }
                case 'Monthly': {
                    $('.repeat-every').text('months');
                    $('.recurring-weekly-group').hide();
                    break;
                }
            }
        };
        toggleTaskRecurringType($('.taskRecurring-taskRecurringType').find(':selected').val());
        $('.taskRecurring-taskRecurringType').change(function() {
            toggleTaskRecurringType($(this).val());
        });

        // NEVER,AFTER,ON,YEARLY TaskRecurringEndsType
        const toggleTaskRecurringEndsType = function(taskRecurringEndsType: any) {
            switch (taskRecurringEndsType) {
                case 'Never': {
                    $('.occurrences-type').hide();
                    $('.specificdate-type').hide();
                    break;
                }
                case 'After': {
                    $('.occurrences-type').show();
                    $('.specificdate-type').hide();
                    break;
                }
                case 'On': {
                    $('.occurrences-type').hide();
                    $('.specificdate-type').show();
                    break;
                }
            }
        };

        toggleTaskRecurringEndsType($('.taskRecurring-ends').find(':selected').val());
        $('.taskRecurring-ends').change(function() {
            toggleTaskRecurringEndsType((this as HTMLInputElement).value);
        });

        const toggleIsAllDayEvent = function(isAllDayEvent: boolean) {
            if (isAllDayEvent) {
                $('.start-by-time').hide();
                $('.complete-by-time').hide();
            } else {
                $('.start-by-time').show();
                $('.complete-by-time').show();
            }
        };

        toggleIsAllDayEvent($('.taskRecurring-isAllDay').is(':checked'));
        $('.taskRecurring-isAllDay').change(function() {
            toggleIsAllDayEvent((this as HTMLInputElement).checked);
        });
    }

    let _map: L.Map;
    let _currentLatLon: L.LatLng;
    let _currentText: string;
    let _latLonUser: string;
    let _marker: L.Marker;
    let _taskAddressSelectors: TaskAddressSelectors;
    let _canSave: boolean;

    export function initAddressMap(taskAddressSelectors: TaskAddressSelectors, latLonUser: string, canSave: boolean = true) {
        _latLonUser = latLonUser;
        _taskAddressSelectors = taskAddressSelectors;
        _canSave = canSave;

        initmap();

        const locatebtn = $('#locatebtn');
        const completeAtText: JQuery<HTMLInputElement> = $('#' + _taskAddressSelectors.completeAtText);

        ui.enableDisableIfPopulated(completeAtText, locatebtn);

        // Hook locatebtn link
        locatebtn.click(function(event) {
            event.preventDefault();

            // The Geo api seems to bypass the disabled so return here if this btn is disabled.
            if (ui.isElementDisabled($(this)))
                return;

            findLocation();
        });

    }

    function initmap() {
        _map = ui.mapInit('map', 0, 0, 11, false);

        const savedLat = $('#' + _taskAddressSelectors.completeAtLat).val() as any;
        const savedLon = $('#' + _taskAddressSelectors.completeAtLon).val() as any;

        const userLatLonBits: any[] = _latLonUser.split(',');
        const userLat: number = userLatLonBits[0];
        const userLon: number = userLatLonBits[1];

        if (savedLat !== '0') {
            _currentLatLon = new L.LatLng(savedLat as number, savedLon as number);
            initMarker();
            _map.setView(_currentLatLon, 15);
        } else {
            _currentLatLon = new L.LatLng(userLat, userLon); // default to user's country
            initMarker();
            _map.setView(_currentLatLon, 6);

            _map.on('locationfound', function(event: any) {
                _currentLatLon = event.latlng;
                initMarker();
                _map.setView(_currentLatLon, 11);
            });
            _map.locate({ timeout: 5000 });
        }
    }

    function initMarker() {
        // Add a single marker that can be dragged around by the user
        if (_canSave) {
            _marker = new L.Marker(_currentLatLon, { draggable: true });
            _marker.on('dragend', markerDragged);
        } else
            _marker = new L.Marker(_currentLatLon, { draggable: false });

        const icon = L.divIcon({
            html: '<div class="appn-mapPin"></div>' +
                '<div class="appn-mapShadow"></div>'
        });

        _marker.setIcon(icon);

        _map.addLayer(_marker);
    }

    function markerDragged(event: any) {
        // if a marker is dragged then update current lat lon
        setCurrent(event.target.getLatLng(), $('#' + _taskAddressSelectors.completeAtLot).val() + ', ' + $('#' + _taskAddressSelectors.completeAtText).val());
        setMarker(Math.max(_map.getZoom(), 10));
        $('#searchResults').html('');
    }

    function setCurrent(latlng: L.LatLng, text: string) {
        _currentLatLon = latlng;
        $('#' + _taskAddressSelectors.completeAtLat).val(_currentLatLon.lat);
        $('#' + _taskAddressSelectors.completeAtLon).val(_currentLatLon.lng);

        if (text.length > 3)
            _currentText = text;
        else
            _currentText = T('Unknown street address');
    }

    function setMarker(zoomlevel: number) {
        if (_marker === undefined)
            initMarker();

        _marker.unbindPopup();

        if (_currentText.length > 1) {
            const popupText = `<div class="appnMapPopup"><h5>${_currentText}</h5><span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${_currentLatLon.lat} ${_currentLatLon.lng}</span></div>`;
            const popup = _marker.bindPopup(popupText);
            popup.openPopup();
        }

        // Refresh marker spot
        _marker.setLatLng(_currentLatLon);
        if (zoomlevel !== undefined)
            _map.setView(_currentLatLon, zoomlevel);
        else
            _map.setView(_currentLatLon, _map.getZoom());
    }

    function findLocation() {
        const lastResult: Array<LastRes> = [];
        let locateText = $('#' + _taskAddressSelectors.completeAtLot).val() + ' ' + $('#' + _taskAddressSelectors.completeAtText).val() + ' ' + $('#' + _taskAddressSelectors.completeAtCountry).val();
        locateText = locateText.replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/, /g, '+').replace(/,/g, '+').replace(/ /g, '+');

        if (!locateText)
            return;

        $('#searchResults').html('<i>' + T('Searching...') + '</i>');

        appn.services.findLocationFromAddress(locateText, function (data: Array<GeoCodeLocation>) {
            let html = '<ul class="list-unstyled mt-3">';

            if (utils.hasValue(data)) {
                data.forEach((geoCodeLocation: GeoCodeLocation, index: number, results: Array<GeoCodeLocation>) => {
                    lastResult[index] = { location: geoCodeLocation, latlng: new L.LatLng(geoCodeLocation.Lat, geoCodeLocation.Lon) };
                    html += `<li>
                                <input class="mt-0" value="${index}" name="result" id="result${index}" type="radio"></input>
                                <label style="cursor:pointer" class="pl-8" for="result${index}"><i> ${geoCodeLocation.DisplayName}</i></label>
                            </li>`;
                });

                html += '</ul>';
            }
            else
                html = T('No results found');

            $('#searchResults').html(html);

            // Add handlers to all new radios
            $('input:radio').each(function() {
                $(this).click(function() {
                    const current = $(this).val() as number;

                    // If the houseNumber is a number replae the correct inputs
                    // else we add the original string.
                    if (utils.hasValue(lastResult[current].location.Address.HouseNumber)) {
                        $('#' + _taskAddressSelectors.completeAtText).val(lastResult[current].location.DisplayName.replace(lastResult[current].location.Address.HouseNumber + ', ', ''));
                        $('#' + _taskAddressSelectors.completeAtLot).val(lastResult[current].location.Address.HouseNumber);
                    } else {
                        $('#' + _taskAddressSelectors.completeAtText).val(lastResult[current].location.DisplayName);
                        $('#' + _taskAddressSelectors.completeAtLot).val('');
                    }

                    setCurrent(lastResult[current].latlng, lastResult[current].location.DisplayName);
                    setMarker(16);
                });
            });
        });

    }

    /**
     * Filters Assigned To drop down by restrict to group
     * Preserves phantom users like first available and first to claim
     * Disables and hides options instead of removing them
     */
    export function filterAssignedToUsersList($restrictToGroup: JQuery<HTMLElement>) {
        const $assignToUser = $('.task-appUserId');
        const $options = $assignToUser.find('option');

        // Only disable options that have an appn-tz data attribute so phantom users are left behind
        ui.disableElement($assignToUser.find('option[data-appn-tz]')).hide();

        // Get RTG val
        let rtg: any = $restrictToGroup.val();
        if (!rtg || rtg === appn.emptyGuid) {
            // Enable all options if there is no restrict to group selected
            ui.enableElement($assignToUser.find('option')).show();
            return;
        }

        rtg = rtg.replace(/-/g, appn.emptyString); // Replace the - in the guids with empty string so they can be matched

        // Loop through all users and enable the ones in the selected group
        for (let i = 0; i < $options.length; i++) {
            const groups = $($options[i]).data('appn-groups');
            if (!groups)
                // Continue with loop as current User isn't assigned to any groups.
                continue;

            // Enable User
            if (groups.indexOf(rtg) >= 0)
                ui.enableElement($($options[i])).show();
        }

        // If the selected target group is now disabled then reset to None and warn
        const $selectedAssignedTo = $assignToUser.find('option:selected');
        if (ui.isElementDisabled($selectedAssignedTo)) {
            if ($assignToUser.find('option[value="' + appn.emptyGuid + '"]').length)
                $assignToUser.val(appn.emptyGuid); // The Template page has Any user with empty guid as default option
            else
                $assignToUser.val(appn.emptyString);

            appn.toast.notify(toast.Type.warning, T(`The Assigned To User was reset because he/she does not belong to the restricted group <b>'{0}'</b>`, $restrictToGroup.find('option:selected').text()));
        }
    }

    /**
     * Filters the Target User Groups list by the selected Restrict to group
     * Disables and hides options instead of removing them
     */
    export function filterTargetGroupList($restrictToGroup: JQuery<HTMLElement>) {
        const $targetGroup = $('#Task_TargetGroup,#Template_Task_TargetGroup');

        if (!$restrictToGroup.val() || $restrictToGroup.val() === appn.emptyGuid) {
            // Enable all options if no restrict to group is chosen
            ui.enableElement($targetGroup.find('option')).show();
            return;
        }

        // Disable all
        ui.disableElement($targetGroup.find('option')).hide();

        // Always enable None
        ui.enableElement($targetGroup.find('option[value=""]')).show();

        // Always enable the selected restrict to group
        const restrictToGroupId = $restrictToGroup.val();
        ui.enableElement($targetGroup.find('option[value="' + restrictToGroupId + '"]')).show();

        // If the selected target group is now disabled then reset to None and warn
        const $selectedTargetGroup = $targetGroup.find('option:selected');
        if (ui.isElementDisabled($selectedTargetGroup)) {
            $targetGroup.val(appn.emptyString);
            appn.toast.notify(toast.Type.warning, T(`The Assigned To User Group was reset because Restrict Group <b>'{0}'</b> was selected.`, $restrictToGroup.find('option:selected').text()));
        }
    }

    /**
     * Filters the Target Users list by the selected Restrict to group
     * Disables and hides options instead of removing them
     */
    export function filterTargetUsersList($restrictToGroup: JQuery<HTMLElement>) {
        const $targetUsersHidden = $('#Task_TargetUsers,#Template_Task_TargetUsers');
        const $targetUsersSelected = $('#bootstrap-duallistbox-selected-list_Task\\.TargetUsers,#bootstrap-duallistbox-selected-list_Template\\.Task\\.TargetUsers');
        const $targetUsersNonSelected = $('#bootstrap-duallistbox-nonselected-list_Task\\.TargetUsers, #bootstrap-duallistbox-nonselected-list_Template\\.Task\\.TargetUsers');

        const $optionsHidden = $targetUsersHidden.find('option');
        const $optionsSelected = $targetUsersSelected.find('option');
        const $optionsNonSelected = $targetUsersNonSelected.find('option');

        // Only disable options that have an appn-tz data attribute so phantom users are left behind
        ui.disableElement($optionsHidden).hide();
        ui.disableElement($optionsSelected).hide();
        ui.disableElement($optionsNonSelected).hide();

        // Get RTG val
        let rtg: any = $restrictToGroup.val();
        if (!rtg || rtg === appn.emptyGuid) {
            // Enable all options if there is no restrict to group selected
            ui.enableElement($targetUsersHidden.find('option')).show();
            ui.enableElement($targetUsersSelected.find('option')).show();
            ui.enableElement($targetUsersNonSelected.find('option')).show();
            return;
        }

        rtg = rtg.replace(/-/g, appn.emptyString); // Replace the - in the guids with empty string so they can be matched

        // Loop through all users and enable the ones in the selected group
        for (let i = 0; i < $optionsHidden.length; i++) {
            const groups = $($optionsHidden[i]).data('appn-groups');
            if (!groups)
                // Continue with loop as current User isn't assigned to any groups.
                continue;

            // Enable User
            if (groups.indexOf(rtg) >= 0)
                ui.enableElement($($optionsHidden[i])).show();
        }

        for (let i1 = 0; i1 < $optionsSelected.length; i1++) {
            const groups1 = $($optionsSelected[i1]).data('appn-groups');
            if (!groups1)
                // Continue with loop as current User isn't assigned to any groups.
                continue;

            // Enable User
            if (groups1.indexOf(rtg) >= 0)
                ui.enableElement($($optionsSelected[i1])).show();
        }

        for (let i2 = 0; i2 < $optionsNonSelected.length; i2++) {
            const groups2 = $($optionsNonSelected[i2]).data('appn-groups');
            if (!groups2)
                // Continue with loop as current User isn't assigned to any groups.
                continue;

            // Enable User
            if (groups2.indexOf(rtg) >= 0)
                ui.enableElement($($optionsNonSelected[i2])).show();
        }

        // If the selected target group is now disabled then reset to None and warn
        const $selectedAssignedTo = $targetUsersHidden.find('option:selected');
        if (ui.isElementDisabled($selectedAssignedTo)) {
            if ($targetUsersHidden.find('option[value="' + appn.emptyGuid + '"]').length)
                $targetUsersHidden.val(appn.emptyGuid); // The Template page has Any user with empty guid as default option
            else
                $targetUsersHidden.val(appn.emptyString);

            appn.toast.notify(toast.Type.warning, T(`One or more of the selected Assigned To Users are disabled because they do not belong to the restricted group <b>'{0}'</b>`, $restrictToGroup.find('option:selected').text()));
        }
    }

    /**
     * Shows the Tasks Add New Dialog
     */
    export function showAddNewDialog(isTaskRecurringContext?: boolean, overideTime?: boolean, startByUtc?: string,
        completeByUtc?: string, isAllDay?: boolean, returnAction?: string) {

        let url = appn.urls.taskTemplates.wizard1;
        if (isTaskRecurringContext)
            url += '?isTaskRecurringContext=true';

        if (returnAction)
            url += `?returnAction=${returnAction}`;

        if (overideTime) {
            if (!isTaskRecurringContext)
                url += '?';
            else
                url += '&';

            url += `startByUtc=${encodeURIComponent(startByUtc ? startByUtc : emptyString)}
                &completeByUtc=${encodeURIComponent(completeByUtc ? completeByUtc : emptyString)}&isAllDay=${isAllDay ? isAllDay : false}`;
        }

        const selectedTemplateId = appn.taskTemplateFilter.getValue();
        if (selectedTemplateId) {
            if (url.indexOf('?') === -1)
                url += '?';
            else
                url += '&';

            url += `Wizard1TemplateId=${encodeURIComponent(selectedTemplateId)}`;
        }

        appn.iframe.openModal({ url: url })
            .then(function($modal: any) {
                $modal.on('hidden.bs.modal', function() {
                    // not using location.reload() as it'll repost if the current page is the result of a post. Force it to do a GET
                    appn.location.reloadCurrentPage();
                });
            });
    }

    export enum TaskStatus {
        Draft,
        Sent,
        Accepted,
        Rejected,
        InProgress,
        Completed
    }

    interface TaskAddressSelectors {
        completeAtLot: string;
        completeAtText: string;
        completeAtCountry: string;
        completeAtLat: string;
        completeAtLon: string;
    }


    /**
     * MappingUtils.Geocode(address);
     * This is the interface for the data structure being returned from the services library used to do geocoding of addresses
     */

    interface GeoCodeAddress {
        City: string;
        Country: string;
        CountryCode: string;
        County: string;
        HouseNumber: string;
        Neighbourhood: string;
        PostCode: string;
        Road: string;
        State: string;
        Suburb: string;
    }

    interface GeoCodeLocation {
        Address: GeoCodeAddress;
        DisplayName: string;
        Lat: number;
        Lon: number;
    }

    interface LastRes {
        location: GeoCodeLocation;
        latlng: L.LatLng;
    }
}
